import { render, staticRenderFns } from "./settlement.vue?vue&type=template&id=64137925&scoped=true"
import script from "./settlement.vue?vue&type=script&lang=js"
export * from "./settlement.vue?vue&type=script&lang=js"
import style0 from "./settlement.vue?vue&type=style&index=0&id=64137925&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64137925",
  null
  
)

export default component.exports